query SupplierAvailableDocumentTypes {
  supplierAvailableDocumentTypes {
    nodes {
      id
      documentType
      isAccountingDocument
      _isAppliableDocumentType
    }
  }
}
